function DeleteAccount() {
    return (
    <>
        <p><strong>Begär radering av konto</strong></p>
        <div>
        Din integritet är viktig för oss, och vi är angelägna om att säkerställa en transparent och användarcentrerad upplevelse.<br/>
        För att bättre betjäna dig och respektera dina preferenser har vi effektiviserat processen för att begära radering av din kontoinformation.
        </div>
        <hr />
        <p>Om du har några frågor eller behöver ytterligare hjälp under denna process, tveka inte att kontakta oss via <a href="https://www.sbf.se/">www.sbf.se.</a></p>
        
        <p>Tack för att du är en uppskattad medlem av Folkrace-communityt.</p>
        
        Vänliga hälsningar,<br />
        <strong>Folkrace teamet</strong>
    </>
    );
}

export default DeleteAccount;
